export default __webpack_public_path__ + "static/media/auth-app-web-image.8889d922.png";